export default __webpack_public_path__ + "static/media/kotlin.5821fe73.svg";